export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd152021',
  projectCNPJ: '00894656000103',
  loginNameProject: 'INBRAPEL Embalagens'
}



// WEBPACK FOOTER //
// ./src/config/index.js